import { BACKEND_URL } from "./api";

const CLICK_EVENTS = new Set(["vibebee_venue_view", "vibebee_take_me_there"]);
const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const ATTRIBUTION_STORAGE_KEY = "vibebee_attribution_journey";
const ATTRIBUTION_WINDOW_MS = 24 * 60 * 60 * 1000;

export function rememberVibeBeeJourney(journeyId, savedAt = Date.now()) {
  const safeJourneyId = String(journeyId || "");
  if (!UUID_V4.test(safeJourneyId) || typeof localStorage === "undefined") return false;
  try {
    localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify({ journey_id: safeJourneyId, saved_at: savedAt }));
    return true;
  } catch {
    return false;
  }
}

export function getVibeBeeAttributionJourneyId(now = Date.now()) {
  if (typeof localStorage === "undefined") return "";
  try {
    const stored = JSON.parse(localStorage.getItem(ATTRIBUTION_STORAGE_KEY) || "null");
    const journeyId = String(stored?.journey_id || "");
    const savedAt = Number(stored?.saved_at || 0);
    if (!UUID_V4.test(journeyId) || !Number.isFinite(savedAt) || savedAt > now || now - savedAt > ATTRIBUTION_WINDOW_MS) {
      localStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
      return "";
    }
    return journeyId;
  } catch {
    return "";
  }
}

export async function trackVibeBeeJourneyClick(eventType, card = {}) {
  const journeyId = String(card.journey_id || "");
  const venueId = String(card.canonical_venue_id || card.venue_id || "").slice(0, 120);
  if (!CLICK_EVENTS.has(eventType) || !UUID_V4.test(journeyId) || !venueId) return false;
  rememberVibeBeeJourney(journeyId);

  try {
    const response = await fetch(`${BACKEND_URL}/api/vibes/vibebee/journey-event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({ journey_id: journeyId, event_type: eventType, venue_id: venueId }),
    });
    return response.ok;
  } catch {
    // Measurement must never delay or block customer navigation.
    return false;
  }
}
